import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getPostBySlug } from './posts';
import { BlogSEO } from './BlogSEO';
import './Blog.css';

function BlogPost() {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) {
    return (
      <main className="App-main blog-page">
        <div className="blog-container" style={{ textAlign: 'center', marginTop: '3rem' }}>
          <h2>Post not found</h2>
          <p className="status-text">The blog post you're looking for doesn't exist.</p>
          <Link to="/blog" className="secondary-button" style={{ marginTop: '1rem', display: 'inline-block' }}>← Back to blog</Link>
        </div>
      </main>
    );
  }

  const publishDate = new Date(post.publishedAt).toLocaleDateString('en-CA', { month: 'long', day: 'numeric', year: 'numeric' });

  return (
    <>
      <BlogSEO
        title={`${post.title} — Rentual Blog`}
        description={post.description}
        url={`https://rentual.co/blog/${post.slug}`}
        type="article"
        publishedTime={post.publishedAt}
        modifiedTime={post.updatedAt || post.publishedAt}
        tags={post.tags}
        image={post.image}
      />
      <main className="App-main blog-page">
        <article className="blog-article">
          <div className="blog-container blog-container--narrow">
            <Link to="/blog" className="blog-back-link">← Blog</Link>

            <header className="blog-article-header">
              <div className="blog-card-meta">
                <span className="blog-card-category">{post.category}</span>
                <span className="blog-card-date">{publishDate}</span>
                <span className="blog-card-read-time">{post.readTime}</span>
              </div>
              <h1>{post.title}</h1>
              <p className="blog-article-desc">{post.description}</p>
              {post.author && (
                <p className="blog-article-author">By {post.author}</p>
              )}
            </header>

            {post.image && (
              <div className="blog-article-hero">
                <img src={post.image} alt={post.title} />
              </div>
            )}

            <div
              className="blog-article-content"
              dangerouslySetInnerHTML={{ __html: post.content }}
            />

            {/* Sources */}
            {post.sources && post.sources.length > 0 && (
              <div className="blog-sources">
                <h3>Sources</h3>
                <ul>
                  {post.sources.map((src, i) => (
                    <li key={i}>
                      <a href={src.url} target="_blank" rel="noopener noreferrer">{src.title}</a>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* CTA */}
            <div className="blog-cta">
              <h3>Ready to screen smarter?</h3>
              <p>Get a full credit report, identity verification, and AI risk assessment for $29.</p>
              <Link to="/register?intent=screen" className="primary-button">Screen a tenant →</Link>
            </div>

            {/* Tags */}
            {post.tags && post.tags.length > 0 && (
              <div className="blog-tags">
                {post.tags.map(tag => (
                  <span key={tag} className="blog-tag">{tag}</span>
                ))}
              </div>
            )}
          </div>
        </article>
      </main>
    </>
  );
}

export default BlogPost;
